import { useState } from 'react';
import classNames from 'classnames';
import { string } from 'prop-types';

import ImageBasic from '~/components/Image/ImageBasic';

import style from './ImageLoader.module.scss';

function ImageLoader({
  path,
  src,
  loadingPlaceholder,
  alt,
  className,
  placeholderClassName,
  ...props
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const mutualProps = { alt, ...props };

  return (
    <div className={classNames(style.imageWrapper, className)}>
      {loadingPlaceholder && (
        <ImageBasic
          {...mutualProps}
          src={loadingPlaceholder}
          className={classNames(
            { [style.hidden]: isLoaded },
            style.placeholder,
            placeholderClassName,
          )}
        />
      )}
      <ImageBasic
        {...mutualProps}
        alt={loadingPlaceholder ? ' ' : alt}
        placeholderClassName={placeholderClassName}
        src={src}
        path={path}
        onLoad={() => {
          setIsLoaded(true);
        }}
      />
    </div>
  );
}

ImageLoader.propTypes = {
  alt: string.isRequired,
  loadingPlaceholder: string,
  src: string,
  path: string,
  className: string,
  placeholderClassName: string,
};

export default ImageLoader;
